import {Pipe, PipeTransform} from '@angular/core';
import {TableFilter} from '../../tools/table-filter/table-filter';

@Pipe({
  name: 'tableFilter',
  standalone: true,
  pure: false
})
export class TableFilterPipe implements PipeTransform {

  transform(tableRows: any[], tableFilter: TableFilter): any[] {

    if (!Array.isArray(tableRows)) {
      return tableRows;
    }

    let filters = tableFilter.getFilters();

    return tableRows.filter(tableRow => {
      for (let key in filters) {
        let value = filters[key]?.toString().toLowerCase();

        if (key in tableRow) {
          let field = tableRow[key]?.toString().toLowerCase() ?? '';
          if (!field.includes(value)) {
            return false;
          }
        }
      }
      return true;
    });
  }
}
